import assign = require('object-assign');
import { DIRTY, SAVED, SAVE_REQUEST } from '../constants/SaveState';
import { GET_SUCCESS } from '../constants/ReportTemplate';

import { ISaveStateAction } from '../interfaces/actions';
import { ISaveState } from '../interfaces/states';

const initialState = {
    dirty: false,
    saved: false,
    saveRequest: false
};

export default function SaveState(state: ISaveState = initialState, action: ISaveStateAction): ISaveState {
    switch (action.type) {
        case GET_SUCCESS: {
            return initialState;
        }
        case DIRTY: {
            return {
                dirty: true,
                saved: false,
                saveRequest: false
            };
        }
        case SAVED: {
            return {
                dirty: false,
                saved: true,
                saveRequest: false
            };
        }
        case SAVE_REQUEST: {
            return assign({}, state, {
                saved: false,
                saveRequest: true
            });
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/reducers/saveState.ts